'use strict';

const { h, render } = require('preact');
const OptionDetails = require('../../buy_button_form/components/option_details');

module.exports = data => {
  const props = {
    ...data,
    isTraitsSummary: true,
  };
  const container = document.querySelector('.m-option-b.with-traits');
  const childComponent = container.querySelector('.option-details');
  render(h(OptionDetails, props), container, childComponent);
};
